import { isEmpty } from "lodash";
import userStore from "../stores/UserStore";
import {
  Call,
  ApiUrl,
  PageParams,
  ParseGeneralResponse,
  setObjectToFormData,
  buildQueryString,
  optionalPageParams,
} from "./ApiUtils";
import AppConfig from "../config/AppConfig";

//  store the functions related to account and org level instructions
export const DriverSettlementApi = {
  fetch: ({ page = 1, perPage = AppConfig.ordersPerPage, payload }) => {
    const requestPayload = {
      ...payload,
      agent_ids: payload.agent_ids === "ALL" ? "" : payload.agent_ids
    };

    let url = ApiUrl(
      `v2/driver_shipment_charges?operation_code=GOR&${optionalPageParams(
        page,
        perPage,
        false
      )}`
    );
    return Call("post", url, requestPayload, ParseGeneralResponse, {
      responseDataKeys: {
        reports: "driver_shipment_charges",
        pagination: "meta.pagination",
      },
    });
  },
  export: ({payload }) => {
    const requestPayload = {
      ...payload,
      agent_ids: payload?.agent_ids === "ALL" ? "" : payload.agent_ids
    };

    const url = ApiUrl(
      `v2/driver_shipment_charges?operation_code=GOR`
    );
    return Call("post", url, requestPayload, ParseGeneralResponse, {
      responseDataKeys: {
        file: "report",
        data:""
      },
    });
  },
  saveOrderLines: (payload) => {
    let url = ApiUrl(
      `v2/driver_shipment_charges/update_order_settlement_charges`
    );
    return Call("put", url, payload, ParseGeneralResponse, {
      responseDataKeys: {
        reports: "driver_shipment_charges",
        // driverPayReports: "driver_pay_reports",
        // driverDeductions: "driver_deduction_reports",
      },
    });
  },
  saveAdjustments: (payload) => {
    let url = ApiUrl(
      `v2/driver_shipment_charges/add_settlement_adjustment`
    );
    return Call("put", url, payload, ParseGeneralResponse, {
      responseDataKeys: {
        reports: "driver_shipment_charges",
        // driverPayReports: "driver_pay_reports",
        // driverDeductions: "driver_deduction_reports",
      },
    });
  },
  saveDetailedLines: (payload) => {
    let url = ApiUrl(
      `v2/driver_shipment_charges/update_order_settlement_charges`
    );
    return Call("put", url, payload, ParseGeneralResponse, {
      responseDataKeys: {
        reports: "driver_shipment_charges",
        // driverPayReports: "driver_pay_reports",
        // driverDeductions: "driver_deduction_reports",
      },
    });
  },
  approveLines: (payload) => {
    let url = ApiUrl(
      `v2/driver_shipment_charges/approve_daily_wise_settlements`
    );
    return Call("put", url, payload, ParseGeneralResponse, {
      responseDataKeys: {
        reports: "driver_shipment_charges",
        // driverPayReports: "driver_pay_reports",
        // driverDeductions: "driver_deduction_reports",
      },
    });
  },
  deleteLines: (payload) => {
    let url = ApiUrl(
      `v2/driver_shipment_charges/delete_driver_adjustment`
    );
    return Call("delete", url, payload, ParseGeneralResponse, {
      responseDataKeys: {
        message: "message",
        errors: "errors",
      },
    });
  },
  fetchDriverDeductionsList: (organizationId, driverId) => {
    const url = ApiUrl(
      `v2/driver_shipment_charges/fetch_driver_deductions_list?organization_id=${organizationId}&driver_id=${driverId}`
    );
    return Call("get", url, {}, ParseGeneralResponse, {
      responseDataKeys: {
        deductions: "",
      },
    });
  },
  applyDeductionForDailywiseDriver: (payload) => {
    const url = ApiUrl(
      `v2/driver_shipment_charges/apply_deduction_for_dailywise_driver`
    );
    return Call("post", url, payload, ParseGeneralResponse, {
      responseDataKeys: {
        message: "message",
        errors: "errors",
      },
    });
  },
};

export function fetchUnsettledOrders(
  page = 1,
  perPage = AppConfig.perPage,
  org_id,
  filter={},
  searchValue='',
) {
  const { from_date, to_date, warehouse_ids = '', account_ids = '', driver_ids = '', search_value = '' } = filter;
  let url = ApiUrl(
    `v2/retrigger_driver_settlements/display_unsettled_orders?organization_id=${org_id}&${PageParams(page,perPage)}&driver_ids=${driver_ids}&warehouse_ids=${warehouse_ids}&account_ids=${account_ids}`
  );
  if(!isEmpty(searchValue)) {
    url = `${url}&search_value=${searchValue}`
  } else {
    const start_date = from_date.format('YYYY-MM-DD HH:mm:ss Z')
    const end_date = to_date.format('YYYY-MM-DD HH:mm:ss Z')
    url = `${url}&from_date=${start_date}&to_date=${end_date}`
  }
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: { unsettled_orders: "orders", pagination: "meta.pagination", settlement_on: "settlement_on" },
  });

}

export function startSettlements(data) {
  const url = ApiUrl(
    `v2/retrigger_driver_settlements/start_settlements`
  );
  return Call(
    "post",
    url,
    data,
    ParseGeneralResponse,
    {
      responseDataKeys: {result: ""}
    },
    false
  )
}
